import { render } from "./CounterpartiesPage.vue?vue&type=template&id=0f02b2fd&scoped=true"
import script from "./CounterpartiesPage.vue?vue&type=script&lang=js"
export * from "./CounterpartiesPage.vue?vue&type=script&lang=js"

import "./CounterpartiesPage.vue?vue&type=style&index=0&id=0f02b2fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f02b2fd"]])

export default __exports__